import React from 'react'
import { ColumnInput, ColumnLabel, ColumnsContainer } from '../../CreateParam/StructureColumns/style'
import { ParamType } from '../../CreateParam'
import { CertificateType, verifyConformity } from '..'

interface PropsType {
  param: ParamType
  structureIndex: number
  certificate: CertificateType
  setCertificate: React.Dispatch<React.SetStateAction<CertificateType>>
  showRange: null | number
}

const StructureColumnsInCertificate:React.FC<PropsType> = ({param, structureIndex, certificate, setCertificate, showRange}) => {
  const handleChangevalue = (e:React.ChangeEvent<HTMLInputElement>, id:number) => {
    setCertificate(prev => ({
      ...prev,
      columnsInStructureWithValues: prev.columnsInStructureWithValues.map(column => (
        column.id === id ? {...column, value: e.target.value}
        : column
      ))
    }))
  }
  
  return (
    <ColumnsContainer quantityGrid={param.structures[structureIndex].columns.length}>
      {param.structures[structureIndex].columns.map((column, index) => 
        <ColumnLabel 
          isItLast={index === param.structures[structureIndex].columns.length - 1}
          key={index}
        > {column.name} ({column.unitUsed?.name}) </ColumnLabel>
      )}
      {param.structures[structureIndex].columns.map((column, index) => 
        <ColumnInput
          outOfNorm={!verifyConformity(column, certificate)}
          key={index}
          placeholder={showRange === structureIndex ? 
            `${column.min ? `${column.min} ≤` : ''} ${column.min || column.max ? 'Valor' : 'Sem restriçoes'} ${column.max ? `≤ ${column.max}`: ''}` : `${column.unitUsed?.name}`
          }
          position={index === 0 ? 'first' : index === param.structures[structureIndex].columns.length - 1 ? 'last' : undefined}
          value={showRange !== structureIndex ? certificate.columnsInStructureWithValues.find(item => item.id === column.id)?.value : ''}
          onChange={(e) => handleChangevalue(e, column.id)}
        />
      )}
    </ColumnsContainer>
  )
}

export default StructureColumnsInCertificate